export default String.raw`
<g id="Stopka rozwinieta z ikonami na bialym tle">
    <g id="Kolorowa stopka">
        <rect width="1440" height="533" class="footerColorBackground"/>
        <g id="Frame 15">
            <g id="Frame 21">
                <g id="Kolumna stopki">
                    <g id="Stopka/Naglowek kolumny">
                        <text id="Naglowek" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                            <tspan x="130" y="47.8182">TRANSLATION_Prv_AboutUs</tspan>
                        </text>
                    </g>
                    <g id="Frame 2">
                        <g id="Stopka/Element kolumny">
                            <text id="Label" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="130" y="80.3636">TRANSLATION_Prv_AboutCompany</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_2">
                            <text id="Label_2" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="130" y="108.364">TRANSLATION_Prv_Blog</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_3">
                            <text id="Label_3" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="130" y="136.364">TRANSLATION_Prv_HelpCenter</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_4">
                            <text id="Label_4" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="130" y="164.364">TRANSLATION_Prv_FrontPage</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_5">
                            <text id="Label_5" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="130" y="192.364">TRANSLATION_Prv_TermsAndConditions</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_6">
                            <text id="Label_6" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="130" y="220.364">TRANSLATION_Prv_PrivacyPolicy</tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </g>
            <g id="Kolumna stopki_2">
                <g id="Stopka/Naglowek kolumny_2">
                    <text id="Naglowek_2" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="370.8" y="47.8182">TRANSLATION_Prv_Orders</tspan>
                    </text>
                </g>
                <g id="Frame 2_2">
                    <g id="Stopka/Element kolumny_7">
                        <text id="Label_7" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="370.8" y="80.3636">TRANSLATION_Prv_Shipping</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_8">
                        <text id="Label_8" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="370.8" y="108.364">TRANSLATION_Prv_Payment</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_9">
                        <text id="Label_9" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="370.8" y="136.364">TRANSLATION_Prv_ComplaintsAndReturns</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_10">
                        <text id="Label_10" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="370.8" y="164.364">TRANSLATION_Prv_RightToWithdraw</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_11">
                        <text id="Label_11" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="370.8" y="192.364">TRANSLATION_Prv_FAQ</tspan>
                        </text>
                    </g>
                </g>
            </g>
            <g id="Frame 19">
                <g id="Kolumna stopki_3">
                    <g id="Stopka/Naglowek kolumny_3">
                        <text id="Naglowek_3" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                            <tspan x="611.6" y="47.8182">TRANSLATION_Prv_YourAccount</tspan>
                        </text>
                    </g>
                    <g id="Frame 2_3">
                        <g id="Stopka/Element kolumny_12">
                            <text id="Label_12" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="611.6" y="80.3636">TRANSLATION_Prv_ClientPanel</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_13">
                            <text id="Label_13" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="611.6" y="108.364">TRANSLATION_Prv_LogIn</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_14">
                            <text id="Label_14" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="611.6" y="136.364">TRANSLATION_Prv_Registration</tspan>
                            </text>
                        </g>
                        <g id="Stopka/Element kolumny_15">
                            <text id="Label_15" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="611.6" y="164.364">TRANSLATION_Prv_PasswordReminder</tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </g>
            <g id="Kolumna stopki_4">
                <g id="Stopka/Naglowek kolumny_4">
                    <text id="Naglowek_4" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                        <tspan x="852.4" y="47.8182">TRANSLATION_Prv_ImportantInfo</tspan>
                    </text>
                </g>
                <g id="Frame 2_4">
                    <g id="Stopka/Element kolumny_16">
                        <text id="Label_16" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="80.3636">TRANSLATION_Prv_FunctionsList</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_17">
                        <text id="Label_17" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="108.364">TRANSLATION_Prv_TemplateWizard</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_18">
                        <text id="Label_18" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="136.364">TRANSLATION_Prv_EshopHelpCenter</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_19">
                        <text id="Label_19" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="164.364">TRANSLATION_Prv_PriceListEshop</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_20">
                        <text id="Label_20" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="192.364">TRANSLATION_Prv_IndividualPartnerPages{1}</tspan>
                            <tspan x="852.4" y="208.364">TRANSLATION_Prv_IndividualPartnerPages{2}</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_21">
                        <text id="Label_21" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="236.364">TRANSLATION_Prv_IndividualClientPages{1}</tspan>
                            <tspan x="852.4" y="252.364">TRANSLATION_Prv_IndividualClientPages{2}</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_22">
                        <text id="Label_22" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="280.364">TRANSLATION_Prv_ComarchShop</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_23">
                        <g id="Label_23">
                            <text class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                <tspan x="852.4" y="308.364">TRANSLATION_Prv_ComarchCommunity</tspan>
                            </text>
                        </g>
                    </g>
                    <g id="Stopka/Element kolumny_24">
                        <text id="Label_24" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="336.364">TRANSLATION_Prv_SEOGuide</tspan>
                        </text>
                    </g>
                    <g id="Stopka/Element kolumny_25">
                        <text id="Label_25" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                            <tspan x="852.4" y="364.364">TRANSLATION_Prv_BenefitsPackage</tspan>
                        </text>
                    </g>
                </g>
            </g>
            <g id="Frame 16">
                <g id="Sekcja/Kontakt">
                    <g id="Stopka/Naglowek kolumny_5">
                        <text id="Naglowek_5" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                            <tspan x="1093.2" y="47.8182">TRANSLATION_Prv_Contact</tspan>
                        </text>
                    </g>
                    <g id="zawartosc">
                        <g id="Frame 7">
                            <g id="Interface/Mail" class="footerColorLinks" transform="translate(1092.000000, 67.000000)">
                                <use class="footerColorLinks--stroke" xlink:href="#envelope" width="24" height="24"></use>
                            </g>
                            <g id="Stopka/Element kolumny_26">
                                <text id="Label_26" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                    <tspan x="1125.2" y="84.3636">e-sklep-test@comarch.pl</tspan>
                                </text>
                            </g>
                        </g>
                        <g id="Frame 8">
                            <g id="Interface/Headphones" class="footerColorLinks" transform="translate(1092.000000, 104.000000)">
                                <use class="footerColorLinks--stroke" xlink:href="#headset" width="24" height="24"></use>
                            </g>
                            <g id="Frame 15_2">
                                <g id="Stopka/Element kolumny_27">
                                    <text id="Label_27" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" font-weight="500" letter-spacing="0px">
                                        <tspan x="1125.2" y="120.364">12 681 43 00</tspan>
                                    </text>
                                </g>
                                <g id="Stopka/Element kolumny_28">
                                    <text id="Label_28" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="12" letter-spacing="0px">
                                        <tspan x="1125.2" y="140.364">Pn-Pt. 8:00-16:00</tspan>
                                    </text>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <g id="Kontakt">
                    <g id="Stopka/Naglowek kolumny_6">
                        <text id="Naglowek_6" class="footerColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="16" font-weight="600" letter-spacing="0px">
                            <tspan x="1093.2" y="183.818">TRANSLATION_Prv_FindUs</tspan>
                        </text>
                    </g>
                    <g id="Social">
                        <g id="Group-34" transform="translate(1090.000000, 200.000000)">
                            <image id="Instagram-icon" x="0" y="0" href="./img/instagram.png" height="24" width="24" />
                            <image id="Fb-icon" x="40" y="0" href="./img/fb.png" height="24" width="24" />
                            <image id="Twitter-icon" x="80" y="0" href="./img/twitter.png" height="24" width="24" />
                            <image id="Youtube-icon" x="120" y="0" href="./img/youtube.png" height="24" width="24" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g id="Frame 14">
            <g id="Platnosc-i-dostawa">
                <g id="Frame 18">
                    <g id="Frame 10">
                        <text id="Partnerzy logistyczni" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                            <tspan x="130" y="439.091">TRANSLATION_Prv_LogisticsPartners</tspan>
                        </text>
                        <g id="Frame 5">
                            <g id="icon delivery ">
                                <rect x="288" y="416" width="64" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="Inpost-icon" x="296" y="420" href="./img/deliveryAndPayment/delivery1.png" height="27" width="46" />
                            </g>
                            <g id="Frame 31">
                                <rect x="368" y="416" width="64" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="DPD-icon" x="374" y="423" href="./img/deliveryAndPayment/delivery2.png" height="21" width="50" />
                            </g>
                            <g id="Frame 32">
                                <rect x="448" y="416" width="64" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="Poczta-Polska-icon" x="452" y="422" href="./img/deliveryAndPayment/delivery3.png" height="24" width="56" />
                            </g>
                            <g id="Frame 33">
                                <rect x="528" y="416" width="78" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="DHL-icon" x="532" y="426" href="./img/deliveryAndPayment/delivery4.png" height="15" width="70" />
                            </g>
                        </g>
                    </g>
                    <g id="Frame 11">
                        <text id="Operatorzy-platnosci" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                            <tspan x="638" y="439.091">TRANSLATION_Prv_OperatorsPayment</tspan>
                        </text>
                        <g id="Frame 5_2">
                            <g id="Frame 34">
                                <rect x="795" y="416" width="64" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="PayU-icon" x="802" y="421" href="./img/deliveryAndPayment/payment1.png" height="25" width="50" />
                            </g>
                            <g id="Frame 35">
                                <rect x="875" y="416" width="92" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="eService-icon" x="879" y="428" href="./img/deliveryAndPayment/payment2.png" height="15" width="84" />
                            </g>
                            <g id="Frame 36">
                                <rect x="983" y="416" width="64" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="tpay-icon" x="990" y="424" href="./img/deliveryAndPayment/payment3.png" height="20" width="50" />
                            </g>
                            <g id="Frame 37">
                                <rect x="1063" y="416" width="78" height="36" rx="4" class="footerBannerBackground"/>
                                <image id="przelewy24-icon" x="1069" y="423" href="./img/deliveryAndPayment/payment4.png" height="22" width="65" />
                            </g>
                        </g>
                    </g>
                </g>
                <g id="divider">
                    <rect width="1180" height="1" transform="translate(130 460)" class="footerColorFont"/>
                </g>
            </g>
            <g id="Frame 20">
                <text id="COMARCH SPOLKA AKCYJNA, ALEJA JANA PAWLA II 39A, 31-864, Krakow, Polska, NIP: PL6770065406" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px">
                    <tspan x="130" y="496.636">COMARCH SP&#xd3;&#x141;KA AKCYJNA, ALEJA JANA PAW&#x141;A II 39A, 31-864, Krak&#xf3;w, Polska, NIP: PL6770065406</tspan>
                </text>
                <text id="Comarch SA 2023. All rights reserved Powered by Comarch e-Sklep" class="footerColorLinks" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px">
                    <tspan x="970" y="496.636">© Comarch SA PREVIEW_YEAR. All rights reserved Powered by Comarch e-Sklep®</tspan>
                </text>
            </g>
        </g>
    </g>
</g>
`;